import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { parse, format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function VendaItem({ row, onSelect, isSelected }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const venda = row.original;

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleCheckboxChange = () => onSelect(venda.id);

    const { key, ...rowProps } = row.getRowProps();


    return (
        <tr {...rowProps} className="bmember-b bmember-stroke border-b border-gray-200">
            <td className="text-left xl:p-4 text-sm font-medium">
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                />
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium uppercase text-sm">{venda.numero_pedido}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{venda.descricao}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">R$ {venda.valor_fabrica ?? 0} ({venda.pontos ?? '0'} pontos)</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{venda.nome}<br/>({venda.cpf})</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{venda.razao}<br/>({venda.cnpj})</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">
                {new Date(venda.data_contrato).toLocaleDateString('pt-BR')}
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm uppercase">
                {venda.status}
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">
                {new Date(venda.criado).toLocaleDateString('pt-BR')}
            </td>
            <td className="p-2 pr-0 text-left 1xl:p-4 xl:pr-0 text-xs 1xl:text-sm">
                <div className="flex items-center gap-2">
                    <Link to={`/manager/vendas/editar/${venda.id}`} className="bg-primary w-8 h-8 rounded-full flex items-center justify-center duration-200 ease-in-out hover:bg-opacity-80">
                        <FontAwesomeIcon icon={faEdit} className="text-white ml-[1px] mb-[1px]" />
                    </Link>
                </div>
            </td>
        </tr>
    );
}

export default VendaItem;
